export const ENGLISH_CONTACT_PHONE = '+8613537234309'

const TEXT_TRANSLATIONS = {
  '中': 'ZH',
  '中文': 'ZH',
  '电动三轮车': 'Electric Tricycle',
  '电动生活': 'Electric Mobility',
  '富贵科技': 'FGQ Technology',
  '服务支持': 'Service Support',
  '关于我们': 'About Us',
  '使用指南': 'User Guide',
  '加入我们': 'Careers',
  '荣誉资质': 'Honors and Qualifications',
  '走进富贵泉': 'About FGQ',
  '新闻动态': 'News',
  '联系我们': 'Contact Us',
  '出口': 'Export Sales',
  '首页': 'Home',
  '招聘职位': 'Job Openings',
  '职业详情': 'Job Details',
  '投递简历': 'Submit Resume',
  '头盔系列': 'Helmets',
  '其他装备': 'Accessories',
  '电机科技': 'Motor Technology',
  '减震科技': 'Suspension Technology',
  '舒适科技': 'Comfort Technology',
  '新款上市': 'New Models',
  '热销车型': 'Popular Models',
  '滑动系列': 'Mobility Series',
  '折叠系列': 'Folding Series',
  '大客系列': 'High-capacity Passenger Series',
  '观光车系列': 'Sightseeing Vehicle Series',
  '清运车系列': 'Waste Collection Series',
  '运桶车系列': 'Bin Transport Series',
  '清扫车系列': 'Sweeper Series',
  '燃油清运车系列': 'Fuel-powered Collection Series'
}

const NEWS_TRANSLATIONS = {
  '重庆酉阳经销商订货大会': {
    title: 'Youyang, Chongqing Dealer Order Conference',
    content: '<p>FGQ met with dealer partners in Youyang, Chongqing for an order conference focused on product communication and regional cooperation.</p>'
  },
  '贵州区域经销商参观工厂': {
    title: 'Guizhou Dealers Visit FGQ Factory',
    content: '<p>Dealer partners from Guizhou visited the FGQ factory to learn about its electric tricycle products, manufacturing operations and cooperation opportunities.</p>'
  },
  '五代观光车上新备案及拍摄': {
    title: 'Fifth-Generation Sightseeing Vehicle Product Filing and Media Production',
    content: '<p>The fifth-generation sightseeing vehicle completed product filing and a new round of product photography and media production.</p>'
  },
  '公益行动-广汉小学端午节捐赠': {
    title: 'Dragon Boat Festival Donation to Guanghan Primary School',
    content: '<h2>Community Outreach</h2><p>FGQ joined Guanghan Primary School in a Dragon Boat Festival community outreach activity. The company delivered holiday care packages as practical support and as encouragement for the students’ learning and growth.</p><p>The activity reflects the company’s commitment to supporting its local community and sharing goodwill during a traditional festival.</p>'
  }
}

const PRODUCT_CATEGORY_TRANSLATIONS = {
  '休闲系列': 'Leisure Electric Tricycles',
  '载人系列': 'Passenger Electric Tricycles',
  '货运系列': 'Electric Cargo Tricycles',
  '带篷货运系列': 'Enclosed Cargo Electric Tricycles',
  '折叠系列': 'Folding Electric Tricycles',
  '环卫系列': 'Sanitation Electric Vehicles',
  '特种车系列': 'Special-purpose Electric Vehicles'
}

const PRODUCT_NAME_TRANSLATIONS = {
  58: 'FGQ Tank Electric Tricycle'
}

export function containsChinese(value) {
  return /[\u3400-\u9fff]/.test(String(value || ''))
}

export function translateEnglishText(value) {
  const original = String(value || '')
  const trimmed = original.trim()
  return TEXT_TRANSLATIONS[trimmed] || original
}

export function localizeProductName(product) {
  if (!product || typeof product !== 'object') return 'FGQ Electric Tricycle'
  if (PRODUCT_NAME_TRANSLATIONS[product.id]) return PRODUCT_NAME_TRANSLATIONS[product.id]
  const sourceName = String(product.name || '').trim()
  if (sourceName && !containsChinese(sourceName)) return sourceName
  return product.id ? `FGQ Model ${product.id}` : 'FGQ Electric Tricycle'
}

export function localizeProductCategory(category) {
  const sourceName = String(category && category.name || '').trim()
  if (PRODUCT_CATEGORY_TRANSLATIONS[sourceName]) return PRODUCT_CATEGORY_TRANSLATIONS[sourceName]
  if (sourceName && !containsChinese(sourceName)) return sourceName
  return 'Electric Tricycle Products'
}

export function normalizeEnglishProductCatalog(data) {
  const source = data && typeof data === 'object' ? data : {}
  const tabList = Array.isArray(source.tabList) ? source.tabList : []
  return {
    ...source,
    tabList: tabList.map(category => ({
      ...category,
      name: localizeProductCategory(category),
      intro: containsChinese(category.intro) ? '' : category.intro,
      list: (category.list || []).map(product => ({
        ...product,
        name: localizeProductName(product)
      }))
    }))
  }
}

function localizeMenuItem(item) {
  if (!item || typeof item !== 'object') return item
  const localized = { ...item }
  if (localized.path === '/show?id=0&op=4') {
    localized.path = '/aboutUs'
    localized.name = 'About FGQ'
  } else if (localized.img && localized.id) {
    localized.name = localizeProductName(localized)
  } else if (PRODUCT_CATEGORY_TRANSLATIONS[localized.name]) {
    localized.name = localizeProductCategory(localized)
  } else if (localized.name) {
    localized.name = translateEnglishText(localized.name)
    if (containsChinese(localized.name)) localized.name = 'Product Series'
  }
  if (localized.intro && containsChinese(localized.intro)) localized.intro = ''
  if (localized.line_name) {
    localized.line_name = translateEnglishText(localized.line_name)
    if (containsChinese(localized.line_name)) localized.line_name = 'Product Series'
  }
  if (Array.isArray(localized.list)) localized.list = localized.list.map(localizeMenuItem)
  if (Array.isArray(localized.products)) localized.products = localized.products.map(localizeMenuItem)
  return localized
}

export function normalizeEnglishNavigation(data) {
  const localized = { ...data }
  for (const key of ['ddsh', 'ddsl', 'fgkj', 'fwzc', 'gywm', 'list']) {
    if (Array.isArray(localized[key])) localized[key] = localized[key].map(localizeMenuItem)
  }
  return localized
}

export function localizeHtmlAttributes(html, fallbackAlt = 'FGQ information') {
  return String(html || '')
    .replace(/\b(alt|title)="[^"]*[\u3400-\u9fff][^"]*"/gi, (_, attr) => `${attr}="${fallbackAlt}"`)
    .replace(/\b(alt|title)='[^']*[\u3400-\u9fff][^']*'/gi, (_, attr) => `${attr}='${fallbackAlt}'`)
    .replace(/用车保养周期/g, 'Vehicle Maintenance Schedule')
    .replace(/安全注意事项/g, 'Safety Precautions')
    .replace(/使用安全事项/g, 'Safe Use Instructions')
    .replace(/官方公众号/g, 'Official WeChat Account')
}

export function normalizeEnglishOptions(data) {
  const normalized = { ...data }
  normalized.kf_phone = ENGLISH_CONTACT_PHONE
  normalized.kf_worktime = '8:00–18:00, Monday–Saturday'
  normalized.site_copyright = '© 2025 FGQ. All rights reserved.'
  normalized.site_icp = 'Sichuan ICP Filing No. 16024944'
  normalized.site_name = 'FGQ — Built for everyday mobility'
  for (const key of ['zp_intro', 'zp_content']) {
    normalized[key] = localizeHtmlAttributes(normalized[key], 'FGQ careers')
  }
  return normalized
}

export function normalizeContactItem(item) {
  return {
    ...item,
    title: translateEnglishText(item && item.title),
    phone: ENGLISH_CONTACT_PHONE
  }
}

export function localizeNewsItem(item) {
  const sourceTitle = String(item && item.post_title || '')
  const translation = NEWS_TRANSLATIONS[sourceTitle]
  return {
    ...item,
    post_title: translation ? translation.title : (containsChinese(sourceTitle) ? 'Company Update' : sourceTitle)
  }
}

export function localizeNewsArticle(item) {
  const sourceTitle = String(item && item.post_title || '')
  const sourceContent = String(item && item.post_content || '')
  const translation = NEWS_TRANSLATIONS[sourceTitle]
  if (translation) {
    return { ...item, post_title: translation.title, post_content: translation.content }
  }
  if (containsChinese(sourceTitle) || containsChinese(sourceContent)) {
    return {
      ...item,
      post_title: containsChinese(sourceTitle) ? 'Company Update' : sourceTitle,
      post_content: '<p>An English version of this company update is being prepared. Please contact FGQ for further information.</p>'
    }
  }
  return { ...item, post_content: localizeHtmlAttributes(sourceContent, 'FGQ company update') }
}
